export default __webpack_public_path__ + "static/media/logo-xl-480w.f6e76249.png";